/* Desktop acquisition account shell. Authentication and owner data continue to
   use the shared mobile Supabase controllers; this file only owns the compact
   signed-in header state and dropdown. */

(function () {
  var SESSION_KEY = 'gettmi:session:v1';
  var root = document.querySelector('.gettmi-desktop-gate');
  if (!root) return;

  function routeCommunityPage() {
    var handle = root.getAttribute('data-gettmi-desktop-community-route');
    if (handle !== 'social-impact' && handle !== 'ambassadors') return;
    var communityPage = root.querySelector('[data-gettmi-desktop-community-page="' + handle + '"]');
    if (!communityPage) return;
    var landingMain = root.querySelector('.gettmi-desktop-gate__main');
    var mobileWebDialog = root.querySelector('[data-gettmi-mobile-web-dialog]');
    var heroQr = root.querySelector('.gettmi-desktop-gate__hero-qr');
    var heroArt = root.querySelector('.gettmi-desktop-gate__hero-art');
    if (landingMain) landingMain.hidden = true;
    if (mobileWebDialog) mobileWebDialog.hidden = true;
    if (heroQr) heroQr.hidden = true;
    if (heroArt) heroArt.hidden = true;
    communityPage.hidden = false;
    root.setAttribute('aria-labelledby', 'gettmi-desktop-title-' + handle);
  }

  routeCommunityPage();

  var signIn = root.querySelector('[data-gettmi-desktop-signin]');
  var trigger = root.querySelector('[data-gettmi-desktop-account-trigger]');
  var menu = root.querySelector('[data-gettmi-desktop-account-menu]');
  var name = root.querySelector('[data-gettmi-desktop-account-name]');
  var email = root.querySelector('[data-gettmi-desktop-account-email]');
  var firstAction = menu && menu.querySelector('button');
  var mobileWebOpen = root.querySelector('[data-gettmi-mobile-web-open]');
  var mobileWebDialog = root.querySelector('[data-gettmi-mobile-web-dialog]');
  var mobileWebClose = root.querySelector('[data-gettmi-mobile-web-close]');
  var mobileWebCopy = root.querySelector('[data-gettmi-mobile-web-copy]');
  var mobileWebStatus = root.querySelector('[data-gettmi-mobile-web-status]');
  var mobileWebReturnFocus = true;

  /* Gate on the pointer, not the window width. A phone or tablet gets the storefront
     at any size; a mouse or trackpad machine gets the landing page even in a narrow
     window. Width alone left every iPad and every half-width desktop window in a gap
     with neither experience. Anything that cannot answer the question is treated as
     touch, so an unknown browser lands on the shop rather than a dead end. */
  function isDesktop() {
    if (!window.matchMedia) return false;
    var coarse = window.matchMedia('(hover: none) and (pointer: coarse)');
    if (coarse.media === 'not all') return false;
    return !coarse.matches;
  }

  function desktopAuthPageRequested() {
    return new URL(window.location.href).searchParams.get('gettmi_account') === 'signin';
  }

  function landingUrl() {
    var url = new URL(window.location.href);
    url.searchParams.delete('gettmi_account');
    return url.pathname + url.search + url.hash;
  }

  function openDesktopAuthPage() {
    var opener = document.createElement('button');
    opener.type = 'button';
    opener.hidden = true;
    opener.setAttribute('data-gettmi-open-settings', '');
    document.body.appendChild(opener);
    opener.click();
    opener.remove();
  }

  function openMobileWebDialog() {
    if (!mobileWebDialog) return;
    if (mobileWebStatus) mobileWebStatus.textContent = '';
    mobileWebReturnFocus = true;
    if (typeof mobileWebDialog.showModal === 'function') {
      mobileWebDialog.showModal();
    } else {
      mobileWebDialog.setAttribute('open', '');
    }
    window.requestAnimationFrame(function () {
      mobileWebDialog.focus({ preventScroll: true });
    });
  }

  function restoreMobileWebFocus() {
    if (!mobileWebOpen) return;
    if (mobileWebReturnFocus) mobileWebOpen.focus();
    else mobileWebOpen.blur();
  }

  function closeMobileWebDialog(returnFocus) {
    if (!mobileWebDialog) return;
    mobileWebReturnFocus = returnFocus !== false;
    if (typeof mobileWebDialog.close === 'function') {
      mobileWebDialog.close();
    } else {
      mobileWebDialog.removeAttribute('open');
      restoreMobileWebFocus();
    }
  }

  function legacyCopy(value) {
    var field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    var copied = document.execCommand('copy');
    field.remove();
    return copied;
  }

  async function copyMobileWebLink() {
    if (!mobileWebCopy) return;
    var mobileWebUrl = mobileWebCopy.getAttribute('data-mobile-web-url');
    if (!mobileWebUrl) return;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(mobileWebUrl);
      } else if (!legacyCopy(mobileWebUrl)) {
        throw new Error('Copy command unavailable');
      }
      if (mobileWebStatus) mobileWebStatus.textContent = 'Mobile link copied.';
    } catch (error) {
      if (mobileWebStatus) mobileWebStatus.textContent = 'Could not copy. Scan the QR code instead.';
    }
  }

  if (isDesktop() && desktopAuthPageRequested()) {
    document.documentElement.classList.add('gettmi-desktop-auth-page');
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openDesktopAuthPage, { once: true });
    } else {
      window.setTimeout(openDesktopAuthPage, 0);
    }
  }

  function storedSession() {
    try {
      return JSON.parse(window.localStorage.getItem(SESSION_KEY) || 'null');
    } catch (error) {
      return null;
    }
  }

  function setMenu(open) {
    if (!menu || !trigger) return;
    var next = Boolean(open && isDesktop() && !trigger.hidden);
    menu.hidden = !next;
    trigger.setAttribute('aria-expanded', String(next));
    if (next && firstAction) firstAction.focus();
  }

  function setSignedOut() {
    if (signIn) signIn.hidden = false;
    if (trigger) trigger.hidden = true;
    setMenu(false);
  }

  function setSignedIn(session) {
    if (!session || !session.user_id) {
      setSignedOut();
      return;
    }
    if (signIn) signIn.hidden = true;
    if (trigger) trigger.hidden = false;
    if (email) email.textContent = session.email || '';
    if (name && !name.textContent.trim()) name.textContent = session.email || 'Your account';
  }

  function setProfile(profile, session) {
    var currentProfile = profile || {};
    var currentSession = session || storedSession() || {};
    var fullName = [currentProfile.first_name, currentProfile.last_name].filter(Boolean).join(' ');
    var displayName = currentProfile.username || fullName || currentSession.email || 'Your account';
    if (name) name.textContent = displayName;
    if (email) email.textContent = currentSession.email || '';
    setSignedIn(currentSession);
  }

  root.addEventListener('click', function (event) {
    var webOpener = event.target.closest('[data-gettmi-mobile-web-open]');
    if (webOpener) {
      event.preventDefault();
      mobileWebOpen = webOpener;
      openMobileWebDialog();
      return;
    }
    if (event.target.closest('[data-gettmi-mobile-web-close]')) {
      closeMobileWebDialog(event.detail === 0);
      return;
    }
    if (event.target.closest('[data-gettmi-mobile-web-copy]')) {
      copyMobileWebLink();
      return;
    }
    if (event.target.closest('[data-gettmi-desktop-account-trigger]')) {
      setMenu(menu && menu.hidden);
      return;
    }
    if (event.target.closest('[data-gettmi-desktop-account-menu] button')) {
      setMenu(false);
    }
  });

  if (mobileWebDialog) {
    mobileWebDialog.addEventListener('click', function (event) {
      if (event.target === mobileWebDialog) closeMobileWebDialog(false);
    });
    mobileWebDialog.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') mobileWebReturnFocus = true;
    });
    mobileWebDialog.addEventListener('close', function () {
      restoreMobileWebFocus();
    });
  }

  // A country without an iOS release reaches the existing web-sharing flow on
  // desktop. Consume this fixed intent so refresh does not reopen the dialog.
  var webIntentUrl = new URL(window.location.href);
  if (isDesktop() && mobileWebDialog && webIntentUrl.searchParams.get('gettmi_mobile_web') === '1') {
    webIntentUrl.searchParams.delete('gettmi_mobile_web');
    window.history.replaceState(window.history.state, '', webIntentUrl.pathname + webIntentUrl.search + webIntentUrl.hash);
    openMobileWebDialog();
  }

  document.addEventListener('click', function (event) {
    if (!menu || menu.hidden) return;
    if (!event.target.closest('[data-gettmi-desktop-account-shell]')) setMenu(false);
  });

  document.addEventListener('click', function (event) {
    if (!isDesktop() || !desktopAuthPageRequested()) return;
    if (!event.target.closest('[data-gettmi-settings-close]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(landingUrl());
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !menu || menu.hidden) return;
    setMenu(false);
    if (trigger) trigger.focus();
  });

  document.addEventListener('gettmi:signed-in', function (event) {
    setSignedIn(event.detail && event.detail.session);
  });

  document.addEventListener('gettmi:profile-read', function (event) {
    var detail = event.detail || {};
    setProfile(detail.profile, detail.session);
  });

  document.addEventListener('gettmi:signed-out', setSignedOut);

  document.addEventListener('gettmi:desktop-account-ready', function () {
    if (!desktopAuthPageRequested()) return;
    window.history.replaceState({}, '', landingUrl());
    document.documentElement.classList.remove('gettmi-desktop-auth-page');
  });

  var initialSession = storedSession();
  if (initialSession && initialSession.access_token) setSignedIn(initialSession);
  else setSignedOut();
})();
